// extracted by mini-css-extract-plugin
export default {"benContainer":"BenImage_benContainer__H5MlC","benImg":"BenImage_benImg__1NANU"};